// Shared form atoms used by every onboarding gate page (age, jurisdiction,
// Safe Mode, platform). All values reference --sz-* design tokens.

import type { CSSProperties } from "react";

export const formStack: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-5)",
};

export const fieldGroup: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-2)",
};

export const label: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: "var(--sz-text-muted)",
};

export const labelHint: CSSProperties = {
  ...label,
  color: "var(--sz-text-disabled)",
};

export const input: CSSProperties = {
  background: "var(--sz-bg-surface-2)",
  border: "1px solid var(--sz-border-default)",
  borderRadius: "var(--sz-radius-md)",
  color: "var(--sz-text-primary)",
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-lg)",
  padding: "12px 16px",
  outline: "none",
  width: "100%",
  textTransform: "uppercase",
  letterSpacing: "2px",
};

export const checkboxRow: CSSProperties = {
  display: "flex",
  alignItems: "flex-start",
  gap: "var(--sz-space-3)",
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  color: "var(--sz-text-secondary)",
  lineHeight: 1.55,
  cursor: "pointer",
};

export const checkboxInput: CSSProperties = {
  marginTop: "3px",
  accentColor: "var(--sz-amber)",
};

export const primaryBtn: CSSProperties = {
  background: "var(--sz-amber)",
  color: "var(--sz-text-inverse)",
  border: "none",
  padding: "14px 20px",
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  fontWeight: 500,
  letterSpacing: "1px",
  textTransform: "uppercase",
  borderRadius: "var(--sz-radius-md)",
};

export const secondaryBtn: CSSProperties = {
  background: "transparent",
  color: "var(--sz-text-muted)",
  border: "1px solid var(--sz-border-default)",
  padding: "12px 18px",
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  letterSpacing: "0.5px",
  borderRadius: "var(--sz-radius-md)",
};

export const buttonRow: CSSProperties = {
  display: "flex",
  gap: "var(--sz-space-3)",
  flexWrap: "wrap",
};

export function message(kind: "error" | "info"): CSSProperties {
  return {
    fontFamily: "var(--sz-font-body)",
    fontSize: "var(--sz-body-sm)",
    color: kind === "error" ? "var(--sz-danger-text)" : "var(--sz-success-text)",
    background: kind === "error" ? "var(--sz-danger-dim)" : "var(--sz-success-dim)",
    border: `1px solid ${kind === "error" ? "var(--sz-danger)" : "var(--sz-success)"}`,
    padding: "10px 14px",
    borderRadius: "var(--sz-radius-md)",
  };
}
